import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { Button, FeatureService } from '@spotahome/ui-library';
import ListingChipsContainer from '@spotahome/ui-library/src/tenant/components/ListingChipsContainer';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import { ListingSectionObservable } from '../ListingSection';

import openListingOverviewSimplifiedModal from './ListingOverviewSimplifiedModal';

import './ListingOverviewSimplified.scss';

const MAX_VISIBLE_CHIPS = 8;

const formatFeatures = features =>
  FeatureService.getFeaturesAsList(
    Object.entries(features).reduce(
      (acc, [key, value], i) => ({
        ...acc,
        [key]: { value, order: i }
      }),
      {}
    )
  );

const ListingOverviewSimplified = ({
  listing,
  isRoomsAggregator,
  isWholeApartment,
  listingId,
  propertyFeatures = {},
  propertyFeaturesOldModel = {},
  roomsInApartment = []
}) => {
  const roomIndex =
    !isRoomsAggregator && !isWholeApartment
      ? roomsInApartment.findIndex(r => r.id === listingId)
      : -1;
  const room = roomIndex !== -1 ? roomsInApartment[roomIndex] : null;

  const getRoomNumber = r =>
    r.floorplanReference || r.bedroomNumber || roomIndex + 1;
  const roomNumber = room ? getRoomNumber(room) : null;

  const roomChips = room?.features ? formatFeatures(room.features) : [];
  const propertyChips = propertyFeaturesOldModel
    ? formatFeatures(propertyFeaturesOldModel)
    : [];

  return (
    <ListingSectionObservable
      section="overview"
      className="listing-overview-simplified"
    >
      <ListingTitle role="secondary">
        {trans('listing.overview.place.title')}
      </ListingTitle>
      <ListingChipsContainer
        chipList={[...roomChips, ...propertyChips]}
        maxVisibleChips={MAX_VISIBLE_CHIPS}
        showShowMoreButton={false}
      />
      <Button
        type="button"
        color="link"
        className="listing-overview-simplified__view-more"
        onClick={() =>
          openListingOverviewSimplifiedModal({
            listing,
            roomChips,
            propertyChips,
            roomNumber,
            energyCertificate: propertyFeatures?.energyCertificate,
            emissionsCertificate: propertyFeatures?.emissionsCertificate,
            fullscreenOnMobile: true
          })
        }
      >
        {trans('common.view-more')}
      </Button>
    </ListingSectionObservable>
  );
};

ListingOverviewSimplified.propTypes = {
  listing: PropTypes.object.isRequired,
  isRoomsAggregator: PropTypes.bool.isRequired,
  isWholeApartment: PropTypes.bool.isRequired,
  listingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  propertyFeatures: PropTypes.shape({
    energyCertificate: PropTypes.object,
    emissionsCertificate: PropTypes.object
  }),
  propertyFeaturesOldModel: PropTypes.object,
  roomsInApartment: PropTypes.arrayOf(PropTypes.object)
};

export default ListingOverviewSimplified;
